import { render, staticRenderFns } from "./ApiCredentials.vue?vue&type=template&id=c38f7d9a"
import script from "./ApiCredentials.vue?vue&type=script&lang=js"
export * from "./ApiCredentials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports